import React from 'react'
import PropTypes from 'prop-types'

import Accordion from './Accordion'

function AccordionGrid({ data }) {
  return (
    <div className="accordion-grid">
      <div className="container__inner">
        <h2 className="accordion-grid__header-text">{data.headerText}</h2>
        {data.accordions?.map(accordion => (
          <Accordion data={accordion} key={accordion.title} />
        ))}
      </div>
    </div>
  )
}

AccordionGrid.propTypes = {
  data: PropTypes.object.isRequired
}

export default AccordionGrid
